import React from 'react';
import './assets/scss/themes.scss';
import RouteIndex from 'Routes/Index';
import { ToastContainer } from "react-toastify";

import fakeBackend from "./helpers/AuthType/fakeBackend";
import { LoaderProvider } from './context/LoaderContext';

// Activating fake backend
fakeBackend();

// Import Firebase Configuration file
// import { initFirebaseBackend } from "./helpers/firebase_helper";

// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_APIKEY,
//   authDomain: process.env.REACT_APP_AUTHDOMAIN,
//   databaseURL: process.env.REACT_APP_DATABASEURL,
//   projectId: process.env.REACT_APP_PROJECTID,
//   storageBucket: process.env.REACT_APP_STORAGEBUCKET,
//   messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
//   appId: process.env.REACT_APP_APPID,
//   measurementId: process.env.REACT_APP_MEASUREMENTID,
// };

// init firebase backend
// initFirebaseBackend(firebaseConfig);

function App() {
  return (
    <LoaderProvider>
      <RouteIndex />
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
    </LoaderProvider>
  );
}

export default App;
